import { render, staticRenderFns } from "./SavToolbar.vue?vue&type=template&id=e8524882&"
import script from "./SavToolbar.vue?vue&type=script&lang=js&"
export * from "./SavToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SavToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
